import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useRequestPasswordReset() {
  return useMutation({
    mutationFn: (email: string) => api.post("/api/auth/password-reset/request", { email })
  });
}

export function useConfirmPasswordReset() {
  return useMutation({
    mutationFn: ({ token, newPassword }: { token: string; newPassword: string }) =>
      api.post("/api/auth/password-reset/confirm", { token, newPassword })
  });
}

export function useVerifyEmail() {
  return useMutation({
    mutationFn: (token: string) => api.post(`/api/auth/verify-email/${token}`)
  });
}

export function useResendVerificationEmail() {
  return useMutation({
    mutationFn: () => api.post("/api/auth/verify-email/resend")
  });
}

/** Checks username/email availability in real time as someone types during
 * registration - debounced by the caller, not here, since the right debounce
 * delay depends on the field (username vs email typically feel different). */
export function useCheckAvailability(username: string, email: string, enabled: boolean) {
  return useQuery({
    queryKey: ["check-availability", username, email],
    queryFn: () =>
      api.get<{ usernameAvailable?: boolean; emailAvailable?: boolean }>(
        `/api/auth/check-availability?${username ? `username=${encodeURIComponent(username)}` : ""}${email ? `&email=${encodeURIComponent(email)}` : ""}`
      ),
    enabled: enabled && (!!username || !!email),
    staleTime: 0
  });
}
